import { useLayoutEffect, useReducer, useRef } from 'react';
import type { Dispatch } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import type { MutationKey } from '@tanstack/react-query';

import { initialLoginState, loginReducer } from './loginMachine';
import type { LoginEvent, LoginState } from './loginMachine';

export interface LoginMachine {
  readonly state: LoginState;
  readonly dispatch: Dispatch<LoginEvent>;
  readonly latest: () => LoginState;
  readonly inFlight: (mutationKey: MutationKey) => boolean;
}

export const useLoginMachine = (): LoginMachine => {
  const queryClient = useQueryClient();
  const [state, dispatch] = useReducer(loginReducer, undefined, initialLoginState);
  const latest = useRef(state);
  useLayoutEffect(() => {
    latest.current = state;
  });
  return {
    state,
    dispatch,
    latest: () => latest.current,
    inFlight: (mutationKey) => queryClient.isMutating({ mutationKey }) > 0,
  };
};

export interface Settleable {
  readonly isError: boolean;
  readonly reset: () => void;
}

export const clearSettled = (machine: LoginMachine, mutation: Settleable, key: MutationKey): void => {
  if (mutation.isError && !machine.inFlight(key)) mutation.reset();
};
